import { ErrorMessage, type Props } from '@hookform/error-message';
import FormHelperText from '@mui/material/FormHelperText';
import type { DeepMap, FieldError, FieldErrors, FieldValues } from 'react-hook-form';

type RHFErrorProps<TFieldErrors extends DeepMap<FieldValues, FieldError>> = {
  errors: Props<TFieldErrors, undefined>['errors'];
  mt?: number;
  name: Props<TFieldErrors, undefined>['name'];
};

export const RHFError = <TFieldErrors extends FieldErrors>({ errors, mt = 3, name }: RHFErrorProps<TFieldErrors>) => (
  <ErrorMessage
    errors={errors}
    name={name}
    render={({ message }) => (
      <FormHelperText error margin="dense" sx={{ ml: 0, mt }}>
        {message}
      </FormHelperText>
    )}
  />
);
